(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("highlight.js"), require("marked"));
	else if(typeof define === 'function' && define.amd)
		define("vue-editor", ["highlight.js", "marked"], factory);
	else if(typeof exports === 'object')
		exports["vue-editor"] = factory(require("highlight.js"), require("marked"));
	else
		root["vue-editor"] = factory(root["highlight.js"], root["marked"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_20__, __WEBPACK_EXTERNAL_MODULE_21__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e2519cda9aa3549a11679e28327069b3.eot";

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _main = __webpack_require__(16);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _main2.default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _marked = __webpack_require__(21);

var _marked2 = _interopRequireDefault(_marked);

var _highlight = __webpack_require__(20);

var _highlight2 = _interopRequireDefault(_highlight);

__webpack_require__(12);

__webpack_require__(11);

var _zh = __webpack_require__(7);

var _zh2 = _interopRequireDefault(_zh);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
  highlight: function highlight(code) {
    return _highlight2.default ? _highlight2.default.highlightAuto(code).value : code;
  }
});

function __debounce(fn, delay) {
  var timer = null;
  return function () {
    var context = this;
    var args = arguments;

    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

exports.default = {
  name: 'VueEditor',
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      vmd: null,
      vmdBody: null,
      vmdHeader: null,
      vmdFooter: null,
      vmdEditor: null,
      vmdPreview: null,
      vmdInput: '# hello',
      lang: 'zh',
      isPreview: true,
      isSanitize: false
    };
  },

  computed: {
    vmdValue: function vmdValue() {
      return this.$props.value || this.vmdInput;
    },
    compiledMarkdown: function compiledMarkdown() {
      return (0, _marked2.default)(this.$props.value || this.vmdInput, { sanitize: this.isSanitize });
    },
    vmdEditorStyle: function vmdEditorStyle() {
      return this.isPreview ? null : {
        width: '100%'
      };
    },
    previewClass: function previewClass() {
      return this.isPreview ? 'vf-eye-slash' : 'vf-eye';
    }
  },
  mounted: function mounted() {
    this.__saveDom();

    this.__resize();

    window.addEventListener('resize', this.vmdResize, false);
    this.vmdEditor.addEventListener('scroll', this.vmdSyncScrolling, false);
    this.vmdPreview.addEventListener('scroll', this.vmdSyncScrolling, false);

    this.vmdEditor.focus();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.vmdResize, false);
    this.vmdEditor.removeEventListener('scroll', this.vmdSyncScrolling, false);
    this.vmdPreview.removeEventListener('scroll', this.vmdSyncScrolling, false);

    this.__removeDom();
  },

  methods: {
    vmdActive: function vmdActive() {
      this.$refs.vmd.classList.add('active');
    },
    vmdInactive: function vmdInactive() {
      this.$refs.vmd.classList.remove('active');
    },
    sanitizeHtml: function sanitizeHtml() {
      this.isSanitize = !this.isSanitize;
    },
    vmdSyncScrolling: function vmdSyncScrolling(e) {
      e = e || window.event;
      if (this.vmdEditor === e.target) {
        this.vmdPreview.scrollTop = e.target.scrollTop;
      } else {
        this.vmdEditor.scrollTop = e.target.scrollTop;
      }
    },

    vmdResize: __debounce(function (e) {
      this.__resize();
    }, 100),

    vmdInputting: __debounce(function (value) {
      this.vmdEditor.value = value;
      this.__updateInput();
    }, 100),
    preview: function preview() {
      this.isPreview = !this.isPreview;
    },
    addTab: function addTab() {
      this.__updateInput('\n' + this.__localize('tabText'));
    },
    addStrong: function addStrong() {
      var chunk = void 0,
          cursor = void 0,
          selected = this.__getSelection(),
          content = this.__getContent();

      if (selected.length === 0) {
        chunk = this.__localize('strongText');
      } else {
        chunk = selected.text;
      }

      if (content.substr(selected.start - 2, 2) === '**' && content.substr(selected.end, 2) === '**') {
        this.__setSelection(selected.start - 2, selected.end + 2);
        this.__replaceSelection(chunk);
        cursor = selected.start - 2;
      } else {
        this.__replaceSelection('**' + chunk + '**');
        cursor = selected.start + 2;
      }

      this.__setSelection(cursor, cursor + chunk.length);
      this.__updateInput();
    },
    addItalic: function addItalic() {
      var chunk = void 0,
          cursor = void 0,
          selected = this.__getSelection(),
          content = this.__getContent();

      if (selected.length === 0) {
        chunk = this.__localize('italicText');
      } else {
        chunk = selected.text;
      }

      if (content.substr(selected.start - 1, 1) === '_' && content.substr(selected.end, 1) === '_') {
        this.__setSelection(selected.start - 1, selected.end + 1);
        this.__replaceSelection(chunk);
        cursor = selected.start - 1;
      } else {
        this.__replaceSelection('_' + chunk + '_');
        cursor = selected.start + 1;
      }

      this.__setSelection(cursor, cursor + chunk.length);
      this.__updateInput();
    },
    addStrikethrough: function addStrikethrough() {
      var chunk = void 0,
          cursor = void 0,
          selected = this.__getSelection(),
          content = this.__getContent();

      if (selected.length === 0) {
        chunk = this.__localize('strikethroughText');
      } else {
        chunk = selected.text;
      }

      if (content.substr(selected.start - 2, 2) === '~~' && content.substr(selected.end, 2) === '~~') {
        this.__setSelection(selected.start - 2, selected.end + 2);
        this.__replaceSelection(chunk);
        cursor = selected.start - 2;
      } else {
        this.__replaceSelection('~~' + chunk + '~~');
        cursor = selected.start + 2;
      }

      this.__setSelection(cursor, cursor + chunk.length);
      this.__updateInput();
    },
    addHeading: function addHeading() {
      var chunk = void 0,
          cursor = void 0,
          selected = this.__getSelection(),
          content = this.__getContent(),
          pointer = void 0,
          prevChar = void 0;

      if (selected.length === 0) {
        chunk = this.__localize('headingText');
      } else {
        chunk = selected.text;
      }

      if ((pointer = 4, content.substr(selected.start - pointer, pointer) === '### ') || (pointer = 3, content.substr(selected.start - pointer, pointer) === '###')) {
        this.__setSelection(selected.start - pointer, selected.end);
        this.__replaceSelection(chunk);
        cursor = selected.start - pointer;
      } else if (selected.start > 0 && (prevChar = content.substr(selected.start - 1, 1), !!prevChar && prevChar !== '\n')) {
        this.__replaceSelection('\n\n### ' + chunk);
        cursor = selected.start + 6;
      } else {
        this.__replaceSelection('### ' + chunk);
        cursor = selected.start + 4;
      }

      this.__setSelection(cursor, cursor + chunk.length);
      this.__updateInput();
    },
    addLine: function addLine() {
      this.__updateInput('\n' + this.__localize('lineText'));
    },
    addQuote: function addQuote() {
      var chunk = void 0,
          cursor = void 0,
          selected = this.__getSelection();

      if (selected.length === 0) {
        chunk = this.__localize('quoteText');

        this.__replaceSelection('\n> ' + chunk);

        cursor = selected.start + 3;
      } else {
        if (selected.text.indexOf('\n') < 0) {
          chunk = selected.text;

          this.__replaceSelection('> ' + chunk);

          cursor = selected.start + 2;
        } else {
          var list = [];

          list = selected.text.split('\n');
          chunk = list[0];

          list.forEach(function (k, v) {
            list[k] = '> ' + v;
          });

          this.__replaceSelection('\n\n' + list.join('\n'));

          cursor = selected.start + 4;
        }
      }

      this.__setSelection(cursor, cursor + chunk.length);
      this.__updateInput();
    },
    addCode: function addCode() {
      var chunk = void 0,
          cursor = void 0,
          selected = this.__getSelection(),
          content = this.__getContent();

      if (selected.length === 0) {
        chunk = this.__localize('codeText');
      } else {
        chunk = selected.text;
      }

      if (content.substr(selected.start - 4, 4) === '```\n' && content.substr(selected.end, 4) === '\n```') {
        this.__setSelection(selected.start - 4, selected.end + 4);
        this.__replaceSelection(chunk);
        cursor = selected.start - 4;
      } else if (content.substr(selected.start - 1, 1) === '`' && content.substr(selected.end, 1) === '`') {
        this.__setSelection(selected.start - 1, selected.end + 1);
        this.__replaceSelection(chunk);
        cursor = selected.start - 1;
      } else if (content.indexOf('\n') > -1) {
        this.__replaceSelection('```\n' + chunk + '\n```');
        cursor = selected.start + 4;
      } else {
        this.__replaceSelection('`' + chunk + '`');
        cursor = selected.start + 1;
      }

      this.__setSelection(cursor, cursor + chunk.length);
      this.__updateInput();
    },
    addLink: function addLink() {
      var chunk = void 0,
          cursor = void 0,
          selected = this.__getSelection(),
          link = void 0;

      if (selected.length === 0) {
        chunk = this.__localize('linkText');
      } else {
        chunk = selected.text;
      }

      link = prompt(this.__localize('linkTip'), 'http://');

      var urlRegex = new RegExp('^((http|https)://|(mailto:)|(//))[a-z0-9]', 'i');
      if (link !== null && link !== '' && link !== 'http://' && urlRegex.test(link)) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(link));
        var sanitizedLink = div.innerHTML;

        this.__replaceSelection('[' + chunk + '](' + sanitizedLink + ')');
        cursor = selected.start + 1;

        this.__setSelection(cursor, cursor + chunk.length);
      }
      this.__updateInput();
    },
    addImage: function addImage() {
      var chunk = void 0,
          cursor = void 0,
          selected = this.__getSelection(),
          link = void 0;

      if (selected.length === 0) {
        chunk = this.__localize('imageText');
      } else {
        chunk = selected.text;
      }

      link = prompt(this.__localize('imageTip'), 'http://');

      var urlRegex = new RegExp('^((http|https)://|(//))[a-z0-9]', 'i');
      if (link !== null && link !== '' && link !== 'http://' && urlRegex.test(link)) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(link));
        var sanitizedLink = div.innerHTML;

        this.__replaceSelection('\n![' + chunk + '](' + sanitizedLink + ' "' + this.__localize('imageTitle') + '")');
        cursor = selected.start + 3;

        this.__setSelection(cursor, cursor + chunk.length);
      }
      this.__updateInput();
    },
    addTable: function addTable() {
      var chunk = void 0,
          cursor = void 0,
          selected = this.__getSelection();

      if (selected.length === 0) {
        chunk = '\n' + this.__localize('tableText');
      } else {
        chunk = selected.text;
      }

      this.__replaceSelection(chunk);
      cursor = selected.start;

      this.__setSelection(cursor, cursor + chunk.length);
      this.__updateInput();
    },
    addUl: function addUl() {
      var chunk = void 0,
          cursor = void 0,
          selected = this.__getSelection();

      if (selected.length === 0) {
        chunk = this.__localize('ulText');

        this.__replaceSelection('- ' + chunk);

        cursor = selected.start + 2;
      } else {
        if (selected.text.indexOf('\n') < 0) {
          chunk = selected.text;

          this.__replaceSelection('- ' + chunk);

          cursor = selected.start + 2;
        } else {
          var list = [];

          list = selected.text.split('\n');
          chunk = list[0];

          list.forEach(function (k, v) {
            list[k] = '- ' + v;
          });

          this.__replaceSelection('\n\n' + list.join('\n'));

          cursor = selected.start + 4;
        }
      }

      this.__setSelection(cursor, cursor + chunk.length);
      this.__updateInput();
    },
    addOl: function addOl() {
      var chunk = void 0,
          cursor = void 0,
          selected = this.__getSelection();

      if (selected.length === 0) {
        chunk = this.__localize('olText');
        this.__replaceSelection('1. ' + chunk);

        cursor = selected.start + 3;
      } else {
        if (selected.text.indexOf('\n') < 0) {
          chunk = selected.text;

          this.__replaceSelection('1. ' + chunk);

          cursor = selected.start + 3;
        } else {
          var list = [];

          list = selected.text.split('\n');
          chunk = list[0];

          list.forEach(function (k, v) {
            list[k] = '1. ' + v;
          });

          this.__replaceSelection('\n\n' + list.join('\n'));

          cursor = selected.start + 5;
        }
      }

      this.__setSelection(cursor, cursor + chunk.length);
      this.__updateInput();
    },
    fullscreen: function fullscreen() {},
    __saveDom: function __saveDom() {
      this.vmd = this.$refs.vmd;
      this.vmdBody = this.$refs.vmdBody;
      this.vmdHeader = this.$refs.vmdHeader;
      this.vmdFooter = this.$refs.vmdFooter;
      this.vmdEditor = this.$refs.vmdEditor;
      this.vmdPreview = this.$refs.vmdPreview;
    },
    __removeDom: function __removeDom() {
      this.vmd = null;
      this.vmdBody = null;
      this.vmdHeader = null;
      this.vmdFooter = null;
      this.vmdEditor = null;
      this.vmdPreview = null;
    },
    __resize: function __resize() {
      var vmdHeaderOffset = this.vmdHeader ? this.vmdHeader.offsetHeight : 0,
          vmdFooterOffset = this.vmdFooter ? this.vmdFooter.offsetHeight : 0;
      this.vmdBody.style.height = this.vmd.offsetHeight - vmdHeaderOffset - vmdFooterOffset + 'px';
    },
    __updateInput: function __updateInput(txt) {
      if (txt) {
        this.vmdEditor.value += txt;
      }

      if (!this.$props.value) {
        this.vmdInput = this.vmdEditor.value;
      } else {
        this.$emit('input', this.vmdEditor.value);
      }
      this.vmdEditor.focus();
    },
    __localize: function __localize(tag) {
      return _zh2.default[this.lang][tag];
    },
    __getContent: function __getContent() {
      return this.vmdEditor.value;
    },
    __getSelection: function __getSelection() {
      var e = this.vmdEditor;
      return ('selectionStart' in e && function () {
        var l = e.selectionEnd - e.selectionStart;
        return { start: e.selectionStart, end: e.selectionEnd, length: l, text: e.value.substr(e.selectionStart, l) };
      } || function () {
        return null;
      })();
    },
    __setSelection: function __setSelection(start, end) {
      var e = this.vmdEditor;
      return ('selectionStart' in e && function () {
        e.selectionStart = start;
        e.selectionEnd = end;
        return null;
      } || function () {
        return null;
      })();
    },
    __replaceSelection: function __replaceSelection(text) {
      var e = this.vmdEditor;
      return ('selectionStart' in e && function () {
        e.value = e.value.substr(0, e.selectionStart) + text + e.value.substr(e.selectionEnd, e.value.length);

        e.selectionStart = e.value.length;
        return null;
      } || function () {
        e.value += text;
        return null;
      })();
    }
  }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
    return _c('div', {
      ref: "vmd",
      staticClass: "vmd"
    }, [_c('div', {
      ref: "vmdHeader",
      staticClass: "vmd-header"
    }, [_c('div', {
      staticClass: "vmd-btn-group"
    }, [_c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button",
        "title": "Ctrl + B"
      },
      on: {
        "click": _vm.addStrong
      }
    }, [_c('i', {
      staticClass: "vf-bold"
    })]), _vm._v(" "), _c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button",
        "title": "Ctrl + I"
      },
      on: {
        "click": _vm.addItalic
      }
    }, [_c('i', {
      staticClass: "vf-italic"
    })]), _vm._v(" "), _c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button",
        "title": "Ctrl + H"
      },
      on: {
        "click": _vm.addHeading
      }
    }, [_c('i', {
      staticClass: "vf-header"
    })]), _vm._v(" "), _c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button",
        "title": "Ctrl + D"
      },
      on: {
        "click": _vm.addStrikethrough
      }
    }, [_c('i', {
      staticClass: "vf-strikethrough"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "vmd-btn-group"
    }, [_c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button",
        "title": "Ctrl + U"
      },
      on: {
        "click": _vm.addUl
      }
    }, [_c('i', {
      staticClass: "vf-list-ul"
    })]), _vm._v(" "), _c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button",
        "title": "Ctrl + O"
      },
      on: {
        "click": _vm.addOl
      }
    }, [_c('i', {
      staticClass: "vf-list-ol"
    })]), _vm._v(" "), _c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button",
        "title": "Ctrl + T"
      },
      on: {
        "click": _vm.addTable
      }
    }, [_c('i', {
      staticClass: "vf-table"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "vmd-btn-group"
    }, [_c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button",
        "title": "Ctrl + A"
      },
      on: {
        "click": _vm.addLink
      }
    }, [_c('i', {
      staticClass: "vf-chain"
    })]), _vm._v(" "), _c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button",
        "title": "Ctrl + P"
      },
      on: {
        "click": _vm.addImage
      }
    }, [_c('i', {
      staticClass: "vf-image"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "vmd-btn-group"
    }, [_c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button",
        "title": "Ctrl + C"
      },
      on: {
        "click": _vm.addCode
      }
    }, [_c('i', {
      staticClass: "vf-code"
    })]), _vm._v(" "), _c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button",
        "title": "Ctrl + Q"
      },
      on: {
        "click": _vm.addQuote
      }
    }, [_c('i', {
      staticClass: "vf-quote-left"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "vmd-btn-group"
    }, [_c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.preview
      }
    }, [_c('i', {
      class: _vm.previewClass
    })]), _vm._v(" "), _c('button', {
      staticClass: "vmd-btn vmd-btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": _vm.sanitizeHtml
      }
    }, [_vm._v("HTML")])])]), _vm._v(" "), _c('div', {
      ref: "vmdBody",
      staticClass: "vmd-body"
    }, [_c('textarea', {
      ref: "vmdEditor",
      staticClass: "vmd-editor",
      style: _vm.vmdEditorStyle,
      attrs: {
        "title": "This is a editor."
      },
      domProps: {
        "value": _vm.vmdValue
      },
      on: {
        "input": function input($event) {
          _vm.vmdInputting($event.target.value);
        },
        "focus": _vm.vmdActive,
        "blur": _vm.vmdInactive,
        "keydown": [function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) {
            return null;
          }
          $event.preventDefault();
          _vm.addTab($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "b")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addStrong($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "i")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addItalic($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "d")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addStrikethrough($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "h")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addHeading($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "l")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addLine($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "q")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addQuote($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "c")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addCode($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "a")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addLink($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "p")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addImage($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "t")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addTable($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "u")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addUl($event);
        }, function ($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "o")) {
            return null;
          }
          if (!$event.ctrlKey) {
            return null;
          }
          $event.preventDefault();
          _vm.addOl($event);
        }]
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isPreview,
        expression: "isPreview"
      }],
      ref: "vmdPreview",
      staticClass: "vmd-preview markdown-body",
      domProps: {
        "innerHTML": _vm._s(_vm.compiledMarkdown)
      }
    })]), _vm._v(" "), _c('div', {
      ref: "vmdFooter",
      staticClass: "vmd-footer"
    }, [_c('a', {
      staticClass: "vmd-btn vmd-btn-default vmd-btn-borderless",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Markdown")])])]);
  }, staticRenderFns: [] };

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(3);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = [_index2.default];

var install = function install(Vue) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  Vue.config.keyCodes.a = 65;
  Vue.config.keyCodes.b = 66;
  Vue.config.keyCodes.c = 67;
  Vue.config.keyCodes.d = 68;
  Vue.config.keyCodes.h = 72;
  Vue.config.keyCodes.i = 73;
  Vue.config.keyCodes.l = 76;
  Vue.config.keyCodes.o = 79;
  Vue.config.keyCodes.p = 80;
  Vue.config.keyCodes.q = 81;
  Vue.config.keyCodes.t = 84;
  Vue.config.keyCodes.u = 85;

  components.map(function (component) {
    Vue.component(component.name, component);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

exports.default = { install: install, VueEditor: _index2.default };

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  "zh": {
    "tabText": "    ",
    "strongText": "加粗文本",
    "italicText": "强调文本",
    "strikethroughText": "删除线",
    "headingText": "在这里输入标题",
    "lineText": "----",
    "quoteText": "在这引用",
    "codeText": "在这里输入代码",
    "linkText": "链接描述",
    "linkTip": "输入链接地址",
    "imageText": "图片描述",
    "imageTip": "输入图片地址",
    "imageTitle": "图片标题",
    "tableText": "header 1 | header 2\n---|---\nrow 1 col 1 | row 1 col 2\nrow 2 col 1 | row 2 col 2\n",
    "ulText": "在这里列出文本",
    "olText": "在这里列出文本"
  }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: \"vmd-font\";\n  src: url(" + __webpack_require__(2) + "); /* IE9*/\n  src: url(" + __webpack_require__(2) + "#iefix) format('embedded-opentype'),  url(" + __webpack_require__(15) + ") format('woff'),  url(" + __webpack_require__(14) + ") format('truetype'),  url(" + __webpack_require__(13) + "#vmd-font) format('svg'); /* iOS 4.1- */\n}\n\n[class^=\"vf-\"], [class*=\" vf-\"] {\n  display: inline-block;\n  font: normal normal normal 14px/1 \"vmd-font\";\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.vf-bold:before {\n  content: \"\\E62C\";\n}\n\n.vf-chain:before {\n  content: \"\\E644\";\n}\n\n.vf-code:before {\n  content: \"\\E657\";\n}\n\n.vf-eye-slash:before {\n  content: \"\\E680\";\n}\n\n.vf-eye:before {\n  content: \"\\E681\";\n}\n\n.vf-header:before {\n  content: \"\\E6B2\";\n}\n\n.vf-image:before {\n  content: \"\\E6BC\";\n}\n\n.vf-italic:before {\n  content: \"\\E6C3\";\n}\n\n.vf-list-ul:before {\n  content: \"\\E6CF\";\n}\n\n.vf-list-ol:before {\n  content: \"\\E6D0\";\n}\n\n.vf-quote-left:before {\n  content: \"\\E6FF\";\n}\n\n.vf-quote-right:before {\n  content: \"\\E700\";\n}\n\n.vf-strikethrough:before {\n  content: \"\\E728\";\n}\n\n.vf-table:before {\n  content: \"\\E72D\";\n}\n\n", ""]);

// exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "@font-face {\n  font-family: octicons-link;\n  src: url(data:font/woff;charset=utf-8;base64,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) format('woff');\n}\n\n.markdown-body {\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n  line-height: 1.5;\n  color: #24292e;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 16px;\n  line-height: 1.5;\n  word-wrap: break-word;\n}\n\n.markdown-body .pl-c {\n  color: #969896;\n}\n\n.markdown-body .pl-c1,\n.markdown-body .pl-s .pl-v {\n  color: #0086b3;\n}\n\n.markdown-body .pl-e,\n.markdown-body .pl-en {\n  color: #795da3;\n}\n\n.markdown-body .pl-smi,\n.markdown-body .pl-s .pl-s1 {\n  color: #333;\n}\n\n.markdown-body .pl-ent {\n  color: #63a35c;\n}\n\n.markdown-body .pl-k {\n  color: #a71d5d;\n}\n\n.markdown-body .pl-s,\n.markdown-body .pl-pds,\n.markdown-body .pl-s .pl-pse .pl-s1,\n.markdown-body .pl-sr,\n.markdown-body .pl-sr .pl-cce,\n.markdown-body .pl-sr .pl-sre,\n.markdown-body .pl-sr .pl-sra {\n  color: #183691;\n}\n\n.markdown-body .pl-v,\n.markdown-body .pl-smw {\n  color: #ed6a43;\n}\n\n.markdown-body .pl-bu {\n  color: #b52a1d;\n}\n\n.markdown-body .pl-ii {\n  color: #f8f8f8;\n  background-color: #b52a1d;\n}\n\n.markdown-body .pl-c2 {\n  color: #f8f8f8;\n  background-color: #b52a1d;\n}\n\n.markdown-body .pl-c2::before {\n  content: \"^M\";\n}\n\n.markdown-body .pl-sr .pl-cce {\n  font-weight: bold;\n  color: #63a35c;\n}\n\n.markdown-body .pl-ml {\n  color: #693a17;\n}\n\n.markdown-body .pl-mh,\n.markdown-body .pl-mh .pl-en,\n.markdown-body .pl-ms {\n  font-weight: bold;\n  color: #1d3e81;\n}\n\n.markdown-body .pl-mq {\n  color: #008080;\n}\n\n.markdown-body .pl-mi {\n  font-style: italic;\n  color: #333;\n}\n\n.markdown-body .pl-mb {\n  font-weight: bold;\n  color: #333;\n}\n\n.markdown-body .pl-md {\n  color: #bd2c00;\n  background-color: #ffecec;\n}\n\n.markdown-body .pl-mi1 {\n  color: #55a532;\n  background-color: #eaffea;\n}\n\n.markdown-body .pl-mc {\n  color: #ef9700;\n  background-color: #ffe3b4;\n}\n\n.markdown-body .pl-mi2 {\n  color: #d8d8d8;\n  background-color: #808080;\n}\n\n.markdown-body .pl-mdr {\n  font-weight: bold;\n  color: #795da3;\n}\n\n.markdown-body .pl-mo {\n  color: #1d3e81;\n}\n\n.markdown-body .pl-ba {\n  color: #595e62;\n}\n\n.markdown-body .pl-sg {\n  color: #c0c0c0;\n}\n\n.markdown-body .pl-corl {\n  text-decoration: underline;\n  color: #183691;\n}\n\n.markdown-body .octicon {\n  display: inline-block;\n  vertical-align: text-top;\n  fill: currentColor;\n}\n\n.markdown-body a {\n  background-color: transparent;\n  -webkit-text-decoration-skip: objects;\n}\n\n.markdown-body a:active,\n.markdown-body a:hover {\n  outline-width: 0;\n}\n\n.markdown-body strong {\n  font-weight: inherit;\n}\n\n.markdown-body strong {\n  font-weight: bolder;\n}\n\n.markdown-body h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n.markdown-body img {\n  border-style: none;\n}\n\n.markdown-body svg:not(:root) {\n  overflow: hidden;\n}\n\n.markdown-body code,\n.markdown-body kbd,\n.markdown-body pre {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n\n.markdown-body hr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\n.markdown-body input {\n  font: inherit;\n  margin: 0;\n}\n\n.markdown-body input {\n  overflow: visible;\n}\n\n.markdown-body [type=\"checkbox\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\n.markdown-body * {\n  box-sizing: border-box;\n}\n\n.markdown-body input {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.markdown-body a {\n  color: #0366d6;\n  text-decoration: none;\n}\n\n.markdown-body a:hover {\n  text-decoration: underline;\n}\n\n.markdown-body strong {\n  font-weight: 600;\n}\n\n.markdown-body hr {\n  height: 0;\n  margin: 15px 0;\n  overflow: hidden;\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid #dfe2e5;\n}\n\n.markdown-body hr::before {\n  display: table;\n  content: \"\";\n}\n\n.markdown-body hr::after {\n  display: table;\n  clear: both;\n  content: \"\";\n}\n\n.markdown-body table {\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n\n.markdown-body td,\n.markdown-body th {\n  padding: 0;\n}\n\n.markdown-body h1,\n.markdown-body h2,\n.markdown-body h3,\n.markdown-body h4,\n.markdown-body h5,\n.markdown-body h6 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.markdown-body h1 {\n  font-size: 32px;\n  font-weight: 600;\n}\n\n.markdown-body h2 {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.markdown-body h3 {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.markdown-body h4 {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.markdown-body h5 {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.markdown-body h6 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.markdown-body p {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n\n.markdown-body blockquote {\n  margin: 0;\n}\n\n.markdown-body ul,\n.markdown-body ol {\n  padding-left: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.markdown-body ol ol,\n.markdown-body ul ol {\n  list-style-type: lower-roman;\n}\n\n.markdown-body ul ul ol,\n.markdown-body ul ol ol,\n.markdown-body ol ul ol,\n.markdown-body ol ol ol {\n  list-style-type: lower-alpha;\n}\n\n.markdown-body dd {\n  margin-left: 0;\n}\n\n.markdown-body code {\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, Courier, monospace;\n  font-size: 12px;\n}\n\n.markdown-body pre {\n  margin-top: 0;\n  margin-bottom: 0;\n  font: 12px \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, Courier, monospace;\n}\n\n.markdown-body .octicon {\n  vertical-align: text-bottom;\n}\n\n.markdown-body .pl-0 {\n  padding-left: 0 !important;\n}\n\n.markdown-body .pl-1 {\n  padding-left: 4px !important;\n}\n\n.markdown-body .pl-2 {\n  padding-left: 8px !important;\n}\n\n.markdown-body .pl-3 {\n  padding-left: 16px !important;\n}\n\n.markdown-body .pl-4 {\n  padding-left: 24px !important;\n}\n\n.markdown-body .pl-5 {\n  padding-left: 32px !important;\n}\n\n.markdown-body .pl-6 {\n  padding-left: 40px !important;\n}\n\n.markdown-body::before {\n  display: table;\n  content: \"\";\n}\n\n.markdown-body::after {\n  display: table;\n  clear: both;\n  content: \"\";\n}\n\n.markdown-body>*:first-child {\n  margin-top: 0 !important;\n}\n\n.markdown-body>*:last-child {\n  margin-bottom: 0 !important;\n}\n\n.markdown-body a:not([href]) {\n  color: inherit;\n  text-decoration: none;\n}\n\n.markdown-body .anchor {\n  float: left;\n  padding-right: 4px;\n  margin-left: -20px;\n  line-height: 1;\n}\n\n.markdown-body .anchor:focus {\n  outline: none;\n}\n\n.markdown-body p,\n.markdown-body blockquote,\n.markdown-body ul,\n.markdown-body ol,\n.markdown-body dl,\n.markdown-body table,\n.markdown-body pre {\n  margin-top: 0;\n  margin-bottom: 16px;\n}\n\n.markdown-body hr {\n  height: 0.25em;\n  padding: 0;\n  margin: 24px 0;\n  background-color: #e1e4e8;\n  border: 0;\n}\n\n.markdown-body blockquote {\n  padding: 0 1em;\n  color: #6a737d;\n  border-left: 0.25em solid #dfe2e5;\n}\n\n.markdown-body blockquote>:first-child {\n  margin-top: 0;\n}\n\n.markdown-body blockquote>:last-child {\n  margin-bottom: 0;\n}\n\n.markdown-body kbd {\n  display: inline-block;\n  padding: 3px 5px;\n  font-size: 11px;\n  line-height: 10px;\n  color: #444d56;\n  vertical-align: middle;\n  background-color: #fafbfc;\n  border: solid 1px #c6cbd1;\n  border-bottom-color: #959da5;\n  border-radius: 3px;\n  box-shadow: inset 0 -1px 0 #959da5;\n}\n\n.markdown-body h1,\n.markdown-body h2,\n.markdown-body h3,\n.markdown-body h4,\n.markdown-body h5,\n.markdown-body h6 {\n  margin-top: 24px;\n  margin-bottom: 16px;\n  font-weight: 600;\n  line-height: 1.25;\n}\n\n.markdown-body h1 .octicon-link,\n.markdown-body h2 .octicon-link,\n.markdown-body h3 .octicon-link,\n.markdown-body h4 .octicon-link,\n.markdown-body h5 .octicon-link,\n.markdown-body h6 .octicon-link {\n  color: #1b1f23;\n  vertical-align: middle;\n  visibility: hidden;\n}\n\n.markdown-body h1:hover .anchor,\n.markdown-body h2:hover .anchor,\n.markdown-body h3:hover .anchor,\n.markdown-body h4:hover .anchor,\n.markdown-body h5:hover .anchor,\n.markdown-body h6:hover .anchor {\n  text-decoration: none;\n}\n\n.markdown-body h1:hover .anchor .octicon-link,\n.markdown-body h2:hover .anchor .octicon-link,\n.markdown-body h3:hover .anchor .octicon-link,\n.markdown-body h4:hover .anchor .octicon-link,\n.markdown-body h5:hover .anchor .octicon-link,\n.markdown-body h6:hover .anchor .octicon-link {\n  visibility: visible;\n}\n\n.markdown-body h1 {\n  padding-bottom: 0.3em;\n  font-size: 2em;\n  border-bottom: 1px solid #eaecef;\n}\n\n.markdown-body h2 {\n  padding-bottom: 0.3em;\n  font-size: 1.5em;\n  border-bottom: 1px solid #eaecef;\n}\n\n.markdown-body h3 {\n  font-size: 1.25em;\n}\n\n.markdown-body h4 {\n  font-size: 1em;\n}\n\n.markdown-body h5 {\n  font-size: 0.875em;\n}\n\n.markdown-body h6 {\n  font-size: 0.85em;\n  color: #6a737d;\n}\n\n.markdown-body ul,\n.markdown-body ol {\n  padding-left: 2em;\n}\n\n.markdown-body ul ul,\n.markdown-body ul ol,\n.markdown-body ol ol,\n.markdown-body ol ul {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.markdown-body li>p {\n  margin-top: 16px;\n}\n\n.markdown-body li+li {\n  margin-top: 0.25em;\n}\n\n.markdown-body dl {\n  padding: 0;\n}\n\n.markdown-body dl dt {\n  padding: 0;\n  margin-top: 16px;\n  font-size: 1em;\n  font-style: italic;\n  font-weight: 600;\n}\n\n.markdown-body dl dd {\n  padding: 0 16px;\n  margin-bottom: 16px;\n}\n\n.markdown-body table {\n  display: block;\n  width: 100%;\n  overflow: auto;\n}\n\n.markdown-body table th {\n  font-weight: 600;\n}\n\n.markdown-body table th,\n.markdown-body table td {\n  padding: 6px 13px;\n  border: 1px solid #dfe2e5;\n}\n\n.markdown-body table tr {\n  background-color: #fff;\n  border-top: 1px solid #c6cbd1;\n}\n\n.markdown-body table tr:nth-child(2n) {\n  background-color: #f6f8fa;\n}\n\n.markdown-body img {\n  max-width: 100%;\n  box-sizing: content-box;\n  background-color: #fff;\n}\n\n.markdown-body code {\n  padding: 0;\n  padding-top: 0.2em;\n  padding-bottom: 0.2em;\n  margin: 0;\n  font-size: 85%;\n  background-color: rgba(27,31,35,0.05);\n  border-radius: 3px;\n  color: #f66;\n}\n\n.markdown-body code::before,\n.markdown-body code::after {\n  letter-spacing: -0.2em;\n  content: \"\\A0\";\n}\n\n.markdown-body pre {\n  word-wrap: normal;\n}\n\n.markdown-body pre>code {\n  padding: 0;\n  margin: 0;\n  font-size: 100%;\n  word-break: normal;\n  white-space: pre;\n  background: transparent;\n  border: 0;\n}\n\n.markdown-body .highlight {\n  margin-bottom: 16px;\n}\n\n.markdown-body .highlight pre {\n  margin-bottom: 0;\n  word-break: normal;\n}\n\n.markdown-body .highlight pre,\n.markdown-body pre {\n  padding: 16px;\n  overflow: auto;\n  font-size: 85%;\n  line-height: 1.45;\n  background-color: #f6f8fa;\n  border-radius: 3px;\n}\n\n.markdown-body pre code {\n  display: inline;\n  max-width: auto;\n  padding: 0;\n  margin: 0;\n  overflow: visible;\n  line-height: inherit;\n  word-wrap: normal;\n  background-color: transparent;\n  border: 0;\n}\n\n.markdown-body pre code::before,\n.markdown-body pre code::after {\n  content: normal;\n}\n\n.markdown-body .full-commit .btn-outline:not(:disabled):hover {\n  color: #005cc5;\n  border-color: #005cc5;\n}\n\n.markdown-body kbd {\n  display: inline-block;\n  padding: 3px 5px;\n  font: 11px \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, Courier, monospace;\n  line-height: 10px;\n  color: #444d56;\n  vertical-align: middle;\n  background-color: #fcfcfc;\n  border: solid 1px #c6cbd1;\n  border-bottom-color: #959da5;\n  border-radius: 3px;\n  box-shadow: inset 0 -1px 0 #959da5;\n}\n\n.markdown-body :checked+.radio-label {\n  position: relative;\n  z-index: 1;\n  border-color: #0366d6;\n}\n\n.markdown-body .task-list-item {\n  list-style-type: none;\n}\n\n.markdown-body .task-list-item+.task-list-item {\n  margin-top: 3px;\n}\n\n.markdown-body .task-list-item input {\n  margin: 0 0.2em 0.25em -1.6em;\n  vertical-align: middle;\n}\n\n.markdown-body hr {\n  border-bottom-color: #eee;\n}\n", ""]);

// exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)();
// imports


// module
exports.push([module.i, "\n*[data-v-49a056fa]:focus {\n  outline: none;\n}\n*[data-v-49a056fa],[data-v-49a056fa] :after,[data-v-49a056fa] :before {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.vmd[data-v-49a056fa] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  border: thin solid #ddd;\n  text-align: left;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  border-radius: 5px;\n  -webkit-transition: all .3s linear;\n  -moz-transition: all .3s linear;\n  -ms-transition: all .3s linear;\n  -o-transition: all .3s linear;\n  transition: all .3s linear;\n}\n.vmd.active[data-v-49a056fa] {\n  border-color: #4395ff;\n}\n.vmd .vmd-header[data-v-49a056fa], .vmd .vmd-footer[data-v-49a056fa] {\n  display: block;\n  padding: 6px;\n  border-bottom: thin solid #ddd;\n  background: #f5f5f5;\n}\n.vmd .vmd-header[data-v-49a056fa] {\n  border-bottom: thin solid #ddd;\n}\n.vmd .vmd-footer[data-v-49a056fa] {\n  border-top: thin solid #ddd;\n}\n.vmd .vmd-body[data-v-49a056fa] {\n  height: inherit;\n}\n.vmd-body .vmd-editor[data-v-49a056fa], .vmd-body .vmd-preview[data-v-49a056fa] {\n  display: block;\n  padding: .8rem;\n  height: inherit;\n  width: 50%;\n  min-height: 100px;\n  float: left;\n  overflow: auto;\n}\n.vmd-body .vmd-editor[data-v-49a056fa] {\n  color: #3d4043;\n  font-size: 1rem;\n  line-height: 1.2rem;\n  border: 0;\n  resize: none;\n  background: #00d1b2;\n}\n.vmd-body .vmd-preview[data-v-49a056fa] {\n  background: #fff;\n}\n.vmd-btn[data-v-49a056fa] {\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-image: none;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n.vmd-btn[data-v-49a056fa]:hover {\n  color: #333;\n  text-decoration: none;\n}\n.vmd-btn[data-v-49a056fa]:active,\n.vmd-btn.active[data-v-49a056fa] {\n  background-image: none;\n  outline: 0;\n  -webkit-box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}\n.vmd-btn[data-v-49a056fa]:focus {\n  outline: none;\n}\n.vmd-btn-default[data-v-49a056fa] {\n  color: #333;\n  background-color: #fff;\n  border-color: #ccc;\n}\n.vmd-btn-default[data-v-49a056fa]:hover {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.vmd-btn-default[data-v-49a056fa]:active,\n.vmd-btn-default.active[data-v-49a056fa] {\n  color: #333;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.vmd-btn-borderless[data-v-49a056fa] {\n  padding-top: 7px;\n  padding-bottom: 7px;\n  border: 0;\n}\n.vmd-btn-borderless[data-v-49a056fa], .vmd-btn-borderless[data-v-49a056fa]:hover, .vmd-btn-borderless[data-v-49a056fa]:active, .vmd-btn-borderless.active[data-v-49a056fa] {\n  box-shadow: none;\n  background-color: transparent;\n}\n.vmd-btn-default:hover.vmd-btn-borderless[data-v-49a056fa] {\n  opacity: .5;\n}\n.vmd-btn-default:active.vmd-btn-borderless[data-v-49a056fa], .vmd-btn-default.active.vmd-btn-borderless[data-v-49a056fa] {\n  opacity: .7;\n}\n.vmd-btn-group[data-v-49a056fa] {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n.vmd-btn-group > .vmd-btn[data-v-49a056fa] {\n  position: relative;\n  float: left;\n}\n.vmd-btn-group > .vmd-btn[data-v-49a056fa]:hover,\n.vmd-btn-group > .vmd-btn[data-v-49a056fa]:focus,\n.vmd-btn-group > .vmd-btn[data-v-49a056fa]:active,\n.vmd-btn-group > .vmd-btn.active[data-v-49a056fa] {\n  z-index: 2;\n}\n.vmd-btn-group .vmd-btn + .vmd-btn[data-v-49a056fa],\n.vmd-btn-group .vmd-btn + .vmd-btn-group[data-v-49a056fa],\n.vmd-btn-group .vmd-btn-group + .vmd-btn[data-v-49a056fa],\n.vmd-btn-group .vmd-btn-group + .vmd-btn-group[data-v-49a056fa] {\n  margin-left: -1px;\n}\n.vmd-btn-group > .vmd-btn[data-v-49a056fa]:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n.vmd-btn-group > .vmd-btn[data-v-49a056fa]:first-child {\n  margin-left: 0;\n}\n.vmd-btn-group > .vmd-btn[data-v-49a056fa]:first-child:not(:last-child):not(.dropdown-toggle) {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.vmd-btn-group > .vmd-btn[data-v-49a056fa]:last-child:not(:first-child) {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.vmd-btn-group > .vmd-btn-group[data-v-49a056fa] {\n  float: left;\n}\n.vmd-btn-group > .vmd-btn-group:not(:first-child):not(:last-child) > .vmd-btn[data-v-49a056fa] {\n  border-radius: 0;\n}\n.vmd-btn-group > .vmd-btn-group:first-child:not(:last-child) > .vmd-btn[data-v-49a056fa]:last-child {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.vmd-btn-group > .vmd-btn-group:last-child:not(:first-child) > .vmd-btn[data-v-49a056fa]:first-child {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.vmd-body[data-v-49a056fa]:before, .vmd-body[data-v-49a056fa]:after,\n.vmd-btn-group[data-v-49a056fa]:before, .vmd-btn-group[data-v-49a056fa]:after {\n  display: table;\n  content: '';\n}\n.vmd-body[data-v-49a056fa]:after,\n.vmd-btn-group[data-v-49a056fa]:after {\n  clear: both;\n}\n", ""]);

// exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(8);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(1)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/._css-loader@0.23.1@css-loader/index.js!../../node_modules/._autoprefixer-loader@2.1.0@autoprefixer-loader/index.js!./iconfont.css", function() {
			var newContent = require("!!../../node_modules/._css-loader@0.23.1@css-loader/index.js!../../node_modules/._autoprefixer-loader@2.1.0@autoprefixer-loader/index.js!./iconfont.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(9);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(1)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/._css-loader@0.23.1@css-loader/index.js!../../node_modules/._autoprefixer-loader@2.1.0@autoprefixer-loader/index.js!./markdown.css", function() {
			var newContent = require("!!../../node_modules/._css-loader@0.23.1@css-loader/index.js!../../node_modules/._autoprefixer-loader@2.1.0@autoprefixer-loader/index.js!./markdown.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c981d7f24d458e729f927e0466002949.svg";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a3c6cf34c713131f6a00284516e40077.ttf";

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(19)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(5),
  /* scopeId */
  "data-v-49a056fa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 18 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;
	var sourceMap = obj.sourceMap;

	if (media) {
		styleElement.setAttribute("media", media);
	}

	if (sourceMap) {
		// https://developer.chrome.com/devtools/docs/javascript-debugging
		// this makes source maps inside style tags work properly in Chrome
		css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(10);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(18)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/._css-loader@0.23.1@css-loader/index.js!../../node_modules/._vue-loader@11.3.4@vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-49a056fa\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/._vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./main.vue", function() {
			var newContent = require("!!../../node_modules/._css-loader@0.23.1@css-loader/index.js!../../node_modules/._vue-loader@11.3.4@vue-loader/lib/style-compiler/index.js?{\"id\":\"data-v-49a056fa\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/._vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./main.vue");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_20__;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_21__;

/***/ })
/******/ ]);
});